export enum ButtonType {
  IMAGE = "IMAGE",
  ICON = "ICON",
  COLOR = "COLOR",
  DEFAULT = "DEFAULT",
}
